import React, { useState, useRef } from 'react';

import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';



const LISTA_PERIOCIDAD = [{ id: "01", descripcion: "Diario" }, { id: "02", descripcion: "Semanal" }, { id: "03", descripcion: "Quincenal" }, { id: "04", descripcion: "Mensual" }, { id: "05", descripcion: "Bimestral" }]
const LISTA_MESES = [{ id: "01", descripcion: "Enero" },
{ id: "02", descripcion: "Febrero" },
{ id: "03", descripcion: "Marzo" },
{ id: "04", descripcion: "Abril" },
{ id: "05", descripcion: "Mayo" },
{ id: "06", descripcion: "Junio" },
{ id: "07", descripcion: "Julio" },
{ id: "08", descripcion: "Agosto" },
{ id: "09", descripcion: "Septiembre" },
{ id: "10", descripcion: "Octubre" },
{ id: "11", descripcion: "Noviembre" },
{ id: "12", descripcion: "Diciembre" },
{ id: "13", descripcion: "Enero-Febrero" },
{ id: "14", descripcion: "Marzo-Abril" },
{ id: "15", descripcion: "Mayo-Junio" },
{ id: "16", descripcion: "Julio-Agosto" },
{ id: "17", descripcion: "Septiembre-Octubre" },
{ id: "18", descripcion: "Noviembre-Diciembre" }]

const es = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "Mi", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
  };


export const InformacionGlobal = (props) => {
    let growl = useRef(null);

    const { informacionGlobal, erroresInformacion } = props;


    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;

        informacionGlobal[name]=elValor;
       
    };

    const templateUsoCfdi = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.id} - {option.descripcion}</span>
            </div>
        );
    }
    return (

        <>
            <Growl ref={growl} />
            <h1>Información Global</h1>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                    <h4>Periodicidad:</h4>
                    <Dropdown dataKey="id" id="periodicidad" name="periodicidad" options={LISTA_PERIOCIDAD} value={informacionGlobal.periodicidad || ''} onChange={(e) => handleChange(e, false)} itemTemplate={templateUsoCfdi} optionLabel="descripcion"
                        className={erroresInformacion.periodicidad ? 'p-error' : ''}  placeholder='Periodicidad'/>
                    {erroresInformacion.periodicidad ? <div><br /> <Message severity="error" text={erroresInformacion.periodicidad} /> </div> : null}
                </div>

                <div className="p-col-12 p-md-4">
                    <h4>Meses:</h4>
                    <Dropdown dataKey="id" id="meses" name="meses" options={LISTA_MESES} value={informacionGlobal.meses || ''} onChange={(e) => handleChange(e, false)} itemTemplate={templateUsoCfdi} optionLabel="descripcion"
                        className={erroresInformacion.meses ? 'p-error' : ''} placeholder='Meses'/>
                    {erroresInformacion.meses ? <div><br /> <Message severity="error" text={erroresInformacion.meses} /> </div> : null}
                </div>

                <div className="p-col-12 p-md-4">
                    <h4>Año:</h4>
                      <Calendar  name="anio" value={informacionGlobal.anio || ''}
                        onChange={(e) => handleChange(e, false)} className={erroresInformacion.anio ? 'p-error' : ''} locale={es} view="month" dateFormat="yy" yearNavigator={true} yearRange="2010:2030" placeholder="Año" />
                    {erroresInformacion.anio ? <div><br /> <Message severity="error" text={erroresInformacion.anio} /> </div> : null}
                </div>
            </div>

            
        </>

    );
}